import { FC, ReactNode } from 'react';
import { Button } from 'antd';
import * as Icon from 'react-feather';
import { ApiErrorResponse, ClassifierFormDataType } from '@atlas-frontend/sdk';

import { ClassifierUpload } from './ClassifierUpload';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './CategoryUploadDownloadActions.translations.json';
import { ClassifierDownload } from './ClassifierDownload';

const { addTranslations, useTranslation } = i18nNsFactory(
  'category-upload-download-actions',
);
addTranslations(translations);

interface ClassifierUploadDownloadProps {
  id?: number;
  edit?: boolean;
  onError?: (error: ApiErrorResponse) => void;
  onSuccess: (data: Partial<ClassifierFormDataType>) => void;
}

export const ClassifierUploadDownloadActions: FC<
  ClassifierUploadDownloadProps
> = ({ id, edit, onError, onSuccess }) => {
  const { t } = useTranslation();

  if (!id && !edit) {
    return null;
  }

  let download: ReactNode | null = null;
  if (id) {
    download = (
      <ClassifierDownload
        classifierId={id}
        sections={['CLASSIFIER']}
        confirmMessage={edit ? t('downloadConfirm') : undefined}
      >
        <Button id="download-classifier" icon={<Icon.Download />} />
      </ClassifierDownload>
    );
  }

  let upload: ReactNode | null = null;
  if (edit) {
    upload = (
      <ClassifierUpload
        classifierId={id}
        sections={['CLASSIFIER']}
        onError={onError}
        onSuccess={onSuccess}
        confirmMessage={id ? t('replaceConfirm') : undefined}
        label={t('upload.classifier')}
      />
    );
  }
  return (
    <>
      {upload}
      {download}
    </>
  );
};
